export default "__VITE_ASSET__6b41cefb__"